<template>
  <section class="product-features">
    <form method="post" @submit.prevent="onSend">
      <form-wrapper :validator="$v.form">
        <b-button
          disabled="disabled"
          :loading="sending"
          type="is-primary"
          native-type="submit"
          style="width: 240px; position: absolute; top: 10px; right: 10px;"
        >
          {{ $t('attributes.update_data') }}
        </b-button>

        <b-tabs v-model="activeTab" :animated="false" type="is-box">
          <b-tab-item>
            <template #header>
              <span>{{ $t('attributes.product_remark') }}</span>
              <a
                :href="helpImageUrl('團別名稱.png')"
                @click.prevent="onClickImage(helpImageUrl('團別名稱.png'))"
                style="border: none; padding: 0 4px;"
              >
                <img
                  :src="helpImageUrl('團別名稱.png')"
                  :alt="$t('attributes.product_remark')"
                  width="32"
                />
              </a>
            </template>

            <editor
              ref="remark_editor"
              v-model="form.remark"
              :area="product.image_path"
              :height="editorHeight"
            ></editor>
          </b-tab-item>

          <b-tab-item>
            <template #header>
              <span>{{ $t('attributes.product_schedule_brief') }}</span>
              <a
                :href="helpImageUrl('團別名稱.png')"
                @click.prevent="onClickImage(helpImageUrl('團別名稱.png'))"
                style="border: none; padding: 0 4px;"
              >
                <img
                  :src="helpImageUrl('團別名稱.png')"
                  :alt="$t('attributes.product_schedule_brief')"
                  width="32"
                />
              </a>
            </template>

            <editor
              ref="remark2_editor"
              v-model="form.remark2"
              :area="product.image_path"
              :height="editorHeight"
            ></editor>
          </b-tab-item>
        </b-tabs>
      </form-wrapper>
    </form>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import { PRODUCTS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import Editor from '@/components/editors/Editor4'

export default {
  name: 'ProductRemarkForm',
  components: { Editor },

  props: {
    product: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      sending: false,
      form: this.extractFormValues(this.product),

      activeTab: 0,

      isImageModalActive: false,
      selectedImageUrl: null,

      windowHeight: window.innerHeight
    }
  },
  computed: {
    editorHeight() {
      return this.windowHeight - 360
    }
  },
  validations: {
    form: {
      remark: {},
      remark2: {}
    }
  },
  watch: {
    product(newProduct) {
      this.form = this.extractFormValues(newProduct)
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    extractFormValues(data) {
      return {
        code: data.code,
        remark: data.remark || '',
        remark2: data.remark2 || ''
      }
    },
    async onSend() {
      this.form.remark = this.$refs.remark_editor.getData()
      this.form.remark2 = this.$refs.remark2_editor.getData()

      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const api = `${PRODUCTS_API}/${this.form.code}/remark`

      this.sending = true
      try {
        const res = await this.axios.put(api, this.form)
        this.$emit('updated', res.data.data)
        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    },
    onResize() {
      this.windowHeight = window.innerHeight
    }
  }
}
</script>
